import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import Table from '../../../components/Table';
import { deleteAccount, getAccountList } from '../../../axios/AccountAxios';
import Search from '../../../components/Search';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';

function AccountList() {
  const [account, setAccount] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);
  const [loading, setLoading] = useState(false);

  const navigation = useNavigate();

  const fetchAccountList = async (keyword, page, limit) => {
    try {
      setIsLoading(true);
      const result = await getAccountList(keyword, page, limit);
      setAccount(result.data);
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // const interval = setInterval(() => {
    fetchAccountList(searchKeyword, currentPage, limit);
    // }, 5000); // Polling every 5 seconds
    // return () => clearInterval(interval); // Clear interval on component unmount
  }, [searchKeyword, currentPage, limit]);

  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Account' },
  ];

  const handleSearch = (keyword) => {
    setSearchKeyword(keyword);
    setCurrentPage(1); // Reset to first page when searching
    // setIsLoading(true);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // setIsLoading(true);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1); // Reset to first page when limit changes
    // setIsLoading(true);
  };

  const handleEdit = (id) => {
    navigation(`update/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
          denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
          cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            await deleteAccount(id);
            await fetchAccountList(searchKeyword, currentPage, limit); // Refresh data setelah delete
            swalWithBootstrapButtons.fire({
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              icon: 'success',
            });
            setLoading(false);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
            });
          }
        });
    } catch (error) {
      console.log(error);
      // setIsLoading(false);
    }
  };

  const columnMap = {
    account_code: 'Account Code',
    name1: 'Name 1',
    name2: 'Name 2',
    name3: 'Name 3',
    name4: 'Name 4',
    name5: 'Name 5',
    level: 'Level',
    group: 'Group',
    condition: 'Condition',
    report: 'Report',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  };

  return (
    <div>
      <LoadingOverlay show={loading} message="Deleting data..." />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <div className="card">
        <div className="card-body">
          <div className="table-search-new mb-2">
            <Search onSearch={handleSearch} />
            <div className=""></div>
            <Link className="btn btn-primary rounded-5" to="/account/create">
              <i className="bi bi-plus-circle-dotted"></i>
              <span> New</span>
            </Link>
          </div>
          <Table
            items={account}
            columnMap={columnMap}
            isLoading={isLoading}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            limit={limit}
            onEdit={handleEdit}
            onDelete={handleDelete}
            showEditButton={true}
          />
        </div>
      </div>
    </div>
  );
}

export default AccountList;
